import React from 'react';
import { Box } from '@mui/material';

/**
 * SkeletonList - Renders multiple skeleton components
 * 
 * Generic wrapper for rendering arrays of skeleton components
 * Perfect for list views with repeating items
 * 
 * Props:
 * - component: Skeleton component to render (e.g., TherapistCardSkeleton)
 * - count: Number of skeletons to render (default: 6)
 * - spacing: Gap between skeletons (default: 2)
 * 
 * Usage:
 * ```jsx
 * <SkeletonList component={TherapistCardSkeleton} count={9} />
 * ```
 * 
 * @version 1.0.0 (Feb 2026)
 */

const SkeletonList = ({ 
  component: Component, 
  count = 6, 
  spacing = 2,
  ...props 
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: spacing }}>
      {[...Array(count)].map((_, index) => (
        <Component key={index} {...props} />
      ))}
    </Box>
  );
};

export default SkeletonList;
